// extracted by mini-css-extract-plugin
export default {"item":"IconGridLink-module--item--16c6a","icon":"IconGridLink-module--icon--39ebf"};